export default __webpack_public_path__ + "static/stile-x-digital-cover-0124648a6d29dbdb3741be0176137c4b.gif";